document.addEventListener('submit', function(e) {

  if (!e.target.action.includes('/cart/add')) return;

  const addons = document.querySelectorAll('.product-addon-checkbox:checked');
  if (!addons.length) return;

  e.preventDefault();

  const formData = new FormData(e.target);
  const mainId = formData.get('id');

  const items = [{id: mainId, quantity: 1}];

  addons.forEach(a=>{
    items.push({id: a.value, quantity:1});
  });

  fetch('/cart/add.js',{
    method:'POST',
    headers:{'Content-Type':'application/json'},
    body: JSON.stringify({items})
  }).then(()=>{
    window.location = '/cart';
  });

});